import React from 'react';

import { useUpdateDependent } from '@gogame/screens';

import {
  useCreateMetric,
  useUpdateMetric,
} from 'scenes/Trackers/Tracker/data/mutations';
import { useLoadCustomMetric } from 'scenes/Trackers/Tracker/data/useLoadCustomMetric';

import { MetricForm } from './MetricForm';
import { DISPLAY_NAME } from './constants';

export const MetricFormCreate = ({
  title,
  onSubmit,
  initialValues,
  onClose,
  onSearch,
  ...props
}) => {
  const [createCustomMetric, { isLoading }] = useCreateMetric();
  const updateDependent = useUpdateDependent();

  const handleSubmit = async (metric) => {
    await createCustomMetric({
      values: metric,
      onSearch: (value) => {
        onClose();
        onSearch(value);
      },
    });
    updateDependent();
    onClose();
  };

  return (
    <MetricForm
      title={title}
      onSubmit={handleSubmit}
      loading={isLoading}
      initialValues={initialValues}
      onClose={onClose}
      {...props}
    />
  );
};

export const MetricFormEdit = ({ id, title, onSubmit, onClose, ...props }) => {
  const [updateCustomMetric, { isLoading: isUpdating }] = useUpdateMetric();
  const updateDependent = useUpdateDependent();
  const { data, isLoading } = useLoadCustomMetric(id);
  const handleSubmit = async (values) => {
    await updateCustomMetric({ id, ...values });
    updateDependent();
    onClose();
  };

  return (
    <MetricForm
      title={title}
      onSubmit={handleSubmit}
      loading={isLoading || isUpdating}
      initialValues={data}
      enableReinitialize={true}
      subTitle={data?.[DISPLAY_NAME]}
      entityId={id}
      active={!!data}
      onClose={onClose}
      {...props}
    />
  );
};
